// extracted by css-extract-rspack-plugin
export default {"switch":"ngAVrNhB","disabled":"x4numrxk","input":"kDW5AJJe","track":"EbUyrwC3","checked":"Eu0PvEEA","thumb":"Fc39CVy8"};